(function () {
  // Don’t run inside Theme Editor preview
  if (window.Shopify && Shopify.designMode) return;

  const DEST = 'https://shopify.com/94419484998/account';

  function replaceBtn(btn) {
    if (!btn || btn.tagName.toLowerCase() !== 'button') return;

    // Build an <a> that looks the same as the button, but is a real link
    const a = document.createElement('a');
    a.href = DEST;
    a.rel = 'nofollow noopener';
    a.className = btn.className.replace(/\baction-login\b/g, '');
    a.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Account');
    a.innerHTML = btn.innerHTML;

    // Nuke any popup triggers living on the button
    btn.removeAttribute('data-open-auth-popup');

    // Ensure nothing in the theme steals this click
    a.addEventListener('click', function (e) {
      e.stopPropagation();
    }, true);

    btn.replaceWith(a);
  }

  function run() {
    // Desktop & mobile header account buttons (Umino)
    document.querySelectorAll(
      '.header_account button.header__icon--account, .header_account button[aria-label="header icon account"]'
    ).forEach(replaceBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-apply if header is re-rendered
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
